module.exports = __webpack_public_path__ + "img/KoroneRisu.0862a638.jpg";